var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotfire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.9 32.8",
    style: {
      enableBackground: "new 0 0 32.9 32.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.4,5.5c-0.4-0.2-0.8-0.4-1.1-0.6C19,10.9,12.9,18.2,5,22.3c0.4,1,1,1.9,1.8,2.7 C13.9,20,19.6,13.3,23.4,5.5 M22,4.7c-1.7-0.7-3.6-1-5.5-1C9.6,3.5,3.9,8.9,3.7,15.7c0,0.3,0,0.5,0,0.8c0,1.2,0.1,2.3,0.4,3.4 C11.7,16.9,18.5,10.4,22,4.7 M23.7,5.6C20.4,13.7,15.4,21,9,27c2.2,1.4,4.8,2.2,7.5,2.1C23.3,29.3,29,23.9,29.2,17 c0-0.2,0-0.5,0-0.7C29.2,11.5,27.1,7.7,23.7,5.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotfire);
export default __webpack_public_path__ + "static/media/spotfire.1f34efa781793828a8b1d6d52312b0d3.svg";
export { ForwardRef as ReactComponent };